module.exports = __webpack_public_path__ + "static/media/T11.356718ad.jpg";